<nz-page-header nzTitle="Member Bulk Upload" nzSubtitle="Upload a CSV or Excel file to add multiple members at once." class="mb-3"></nz-page-header>

<div *ngFor="let option of options">
	<div class="mb-5">
		<h3>{{option.payload.label}}</h3>
		<nz-upload
			nzType="drag"
			[nzMultiple]="false"
			[nzCustomRequest]="option.customUpload"
			[nzShowUploadList]="false"
			nzAccept=".csv">
			<p class="ant-upload-drag-icon">
				<i nz-icon nzType="inbox" ></i>
			</p>
			<p *ngIf="!option.uploadedFile" class="ant-upload-text">{{option.payload.description}}</p>
			<p *ngIf="option.uploadedFile" class="ant-upload-text">Uploaded: {{ option.fileName }}</p>
		</nz-upload>
		<ngb-progressbar *ngIf="option.uploadProgress || option.uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="option.uploadProgress" />

	</div>
</div>
<div class="row">
	<div class="col">
		<button nz-button [disabled]="!canSubmit()" (click)="doSave()">Import</button>
	</div>
</div>
